const GROWTHBOOK_FEATURE_FLAGS = {
	REFERRALS_SERVICE: 'referrals_service',
	// Experimento 50/50 del checkout: Stripe Checkout embebido (Checkout Session
	// ui_mode embedded, misma maquinaria del link de WhatsApp) vs el widget propio de
	// PaymentElement. Booleano; se evalúa en checkoutV2/hooks/useEmbeddedCheckoutArm
	// solo al abrir el checkout con monto cobrable. Métrica: purchase_payment_success
	// (origin=checkout_embedded) por usuario expuesto.
	CHECKOUT_EMBEDDED_STRIPE: 'checkout-embedded-stripe',
	// Experimento del premio en heru-cash por vincular el SAT. A diferencia del
	// resto, NO es booleano: su valor ES el monto (0 = control, 100), y el brazo
	// se lee con evalFeature para sacar también el variationId. La única lectura
	// vive en features/sat-connection/linking-reward; esta entrada existe para
	// que el flag aparezca en el registro.
	//
	// El sufijo `-prod` NO significa "sólo producción": GrowthBook maneja los
	// ambientes DENTRO de la feature. Quedó así porque la primera feature se
	// archivó y GrowthBook no libera la clave de una archivada.
	//
	// `v2` es la rotación del 2026-08-25: el exp1 (control/$50/$100) cerró con la
	// conversión plana y se abrió uno de dos brazos (control/$100) para ganar
	// poder estadístico. Es una FEATURE NUEVA y no una fase nueva de la anterior,
	// a propósito: la clave viaja a Amplitude y a la columna experiment_id, así
	// que reusar la vieja habría dejado los dos experimentos bajo un mismo id,
	// separables sólo por fecha. La clave DEBE seguir siendo igual al tracking
	// key del experimento en GrowthBook y a LINKING_REWARD_EXPERIMENT_ID del
	// sales-transaction-engine, que la valida y rechaza cualquier otra.
	LINKING_REWARD_AMOUNT: 'linking-reward-amount-v2-prod',
	// Experimento de elasticidad del descuento de retención del save-flow
	// (question 0022). No booleano: su valor ES el % (30/50/80; default 20 =
	// fuera del experimento). La única lectura vive en shared/discounts +
	// ModalChurn; esta entrada existe para que el flag aparezca en el registro.
	RETENTION_DISCOUNT_PERCENT: 'retention_discount_percent',
	// Experimento de entrada al flujo de vinculación. Booleano: `false` = control
	// (selector de método), `true` = tratamiento (aterriza directo en el
	// formulario del método que le toca por dispositivo — e.firma en desktop,
	// RFC en celular). La única lectura vive en
	// features/sat-connection/linking-flow/experiments.
	LINKING_ENTRY_DIRECT_METHOD: 'linking-entry-direct-method',
	// Umbral de intentos fallidos antes de ofrecer la salida a soporte. No es
	// booleano: su valor ES el número de fallos (3 = control, lo que hay hoy en
	// SUPPORT_RESCUE_AFTER_ATTEMPTS; 1 = tratamiento). Sólo se evalúa para quien
	// ya falló al menos una vez, para no meter al denominador a quien vincula al
	// primer intento y nunca habría visto el botón en ningún brazo.
	LINKING_SUPPORT_RESCUE_THRESHOLD: 'linking-support-rescue-threshold',
	// Experimento del anuncio del primer mes gratis en onboarding. No es
	// booleano: su valor ES la ventana (`none` = control, `day`, `week`,
	// `month`, `always`), anclada al `joined_at` del usuario. Correr 2 brazos o
	// 5 es configuración de GrowthBook, no un cambio de código. La única lectura
	// vive en shared/promos/useFirstMonthFreePromo.
	FIRST_MONTH_FREE_ANNOUNCE: 'first-month-free-announce',
	SHOW_SAT_ERROR_2025: 'show_sat_error_2025',
	SUPPORT_WHATSAPP: 'support_whatsapp',
	PONTE_AL_DIA: 'ponte-al-dia-v1',
	// Modal de NPS del portal (t-015). Booleano: apagado (default cuando la
	// feature no existe en GrowthBook) = sin auto-show. Sirve para prender el
	// auto-show por % y apagar sin deploy. NO gatea el deep link `?nps=1`: quien
	// recibió la invitación (WhatsApp/push) tiene que poder contestar aunque no
	// caiga en el %. Lectura en features/nps/hooks/useNpsAutoShow.
	NPS_MODAL: 'nps_modal',
	// Interruptor de emergencia del deep link `?nps=1` (t-015). Booleano:
	// apagado / inexistente en GrowthBook (default) = el deep link abre el
	// modal. Prenderlo lo corta sin deploy. Lectura en
	// features/nps/hooks/useNpsDeeplink.
	NPS_DEEPLINK_DISABLED: 'nps_deeplink_disabled',
};

export default GROWTHBOOK_FEATURE_FLAGS;
